import { User } from 'oidc-client';
import { Logger } from '../telemetry/loggers/Logger';
import { ImpersonatedCountry } from "../components/common/AuthenticatedComponent";

export type TranslatedLabels = {
    [key: string]: string;
};

type TranslationDynamicLabelFunction = (translationKey: string) => string;

export type TranslatedDynamicLabels = {
    [key: string]: TranslationDynamicLabelFunction;
};

type TranslationParseFunction = (string) => string;

export type ParseTranslations = {
    [key: string]: TranslationParseFunction;
};

export type LanguageKey = 'sv' | 'en' | 'fi';

export enum UserRole {
    Admin = 'role/administrator',
    Support = 'role/support',
    Economist = 'role/economist',
    Management = 'role/management',
    Photographer = 'role/photographer',
    ImageEditor = 'role/image-editor',
    PlanEditor = 'role/plan-editor',
    BrokerAgent = 'role/broker-agent',
    BrokerAgentAssistant = 'role/broker-agent-assistant',
    BrokerAgentAdmin = 'role/broker-agent-admin',
    Seller = 'role/seller',
    ImageEditorAdmin = 'role/image-editor-admin',
    PlanEditorAdmin = 'role/plan-editor-admin',
    StylingAdmin = 'role/styling-admin',
    Stylist = 'role/stylist'
}

export type UserDetails = {
    applicationVersion: string;
    translationsVersion?: number;
    canManageTranslations?: boolean;
    country: number;
    features: string[];
    id: number;
    impersonatedCountry: ImpersonatedCountry | null;
    impersonatedUsername: string;
    firstname: string;
    lastname: string;
    isCustomer: boolean;
    isImpersonated: boolean;
    languageKey: LanguageKey;
    name: string;
    role: UserRole;
    employedBySE360?: boolean;
};

export type AuthenticatedUser = {
    initialized: boolean;
    isAuthenticated: boolean;
    details: UserDetails;
    impersonatedUser: number;
    impersonatedCountry: ImpersonatedCountry | null;
    impersonation?: boolean;
} & User;

export type AuthConfig = {
    authority: string;
    clientId: string;
    redirectUri: string;
    postLogoutRedirectUri: string;
    silentRedirectUri: string;
    scope: string;
};

export type AppConfig = {
    aiTelemetry: string;
    site: string;
    env: 'production' | 'development' | 'test';
    apiUrl: string;
    acfg: AuthConfig;
    projectNewsUrl: string;
    debugEnabled: boolean;
    showcaseUrl: string;
};

declare global {
    export interface Window {
        appConfig: AppConfig;
        aiInitialized: boolean;
        __dateLocale: string;
        logger: Logger;
        __REDUX_DEVTOOLS_EXTENSION__: any;
    }
}
